import React, { useEffect, useState, useContext } from "react";
import useAxiosPrivate from "../../Hooks/useAxiosPrivate";
import AlertContext from "../../context/AlertContext";
import constants from "../../constants";
import { getDataFromStorage } from "../../util";
import { SOALearningStreakSkeleton } from "../Student/DashBoard/SOADashboard/SOAComponents/SOAStudentLearningModuleSection/SOALearningStreakSkeleton";


const LearningStreak = () => {
  const { setShowNotify, setIsLoaded, isLoaded, setActivityData, setCompleteAssignmentsData } = useContext(AlertContext);
  const axios = useAxiosPrivate();
  const [lsData, setLsData] = useState({});

  useEffect(() => {
    const fetchStreaks = async () => {
      setIsLoaded(true);
      try {
        let response = await axios.get(`node/learner/db/streak`, {
          params: { lid: getDataFromStorage("learnerid"),
             companyId: parseInt(localStorage.getItem("companyId")),
           },
          headers: {
            "Content-Type": "application/json",
          },
        });
        if (response.data.resultCode === constants.RESULT_STATUS.SUCCESS) {
          setLsData(response.data.data ?? []);
          setActivityData(response.data.data.activityData ?? []);
          setCompleteAssignmentsData(response.data.data.completeAssignmentsData ?? []);
        } else {
          setShowNotify({
            show: true,
            title: "Error !",
            msg: "Something went wrong. Please try again later or contact gradious team.",
          });
        }
      } catch (error) {
        console.log(error);
        if (error.message.includes("403")) {
          setShowNotify({
            show: true,
            title: "Warning !",
            msg: "You have been logged-out due to inactivity. Login again.",
            isUnAuth: true,
          });
        } else {
          setShowNotify({
            show: true,
            title: "Error !",
            msg: error.message,
          });
        }
      } finally {
        setIsLoaded(false);
      }
    };
    fetchStreaks();
  }, [axios, setIsLoaded, setShowNotify]);

  // console.log("lsData", lsData);

  function getLast7DaysStreak(isStreakList) {
    // console.log("isStreakList", isStreakList);

    const dayNames = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const today = new Date(); // e.g., 2025-08-02
    const result = [];

    for (let i = 6; i >= 0; i--) {
      // start from yesterday
      const date = new Date(today);
      date.setDate(today.getDate() - i);

      const dateStr = date.toISOString().split("T")[0];
      const streakItem = isStreakList.find((item) => item.date === dateStr);

      result.push({
        day: dayNames[date.getDay()],
        date: dateStr,
        isStreak: streakItem ? streakItem.isStreak : "no",
      });
    }

    return result;
  }

  let result = [];
  if (lsData?.isStreak?.length > 0)
    result = getLast7DaysStreak(lsData?.isStreak);
  // console.log("result", result);

  const days = [
    { day: "Mon", status: "not-completed" },
    { day: "Tue", status: "completed" },
    { day: "Wed", status: "completed" },
    { day: "Thu", status: "completed" },
    { day: "Fri", status: "completed" },
    { day: "Sat", status: "completed" },
    { day: "Sun", status: "future" },
  ];

  if(!Object.keys(lsData)?.length){
    return(
    <SOALearningStreakSkeleton/>
    )
  }
  return (
    <div className="learning-streak">
        <>
          {" "}
          <div className="streak-header">
            <h2>Learning Streak</h2>
            <div className="streak-count">
              <span className="count">
                {lsData?.streakCount?.current_streak ?? 0}
              </span>
              <span className="text">day streak</span>
            </div>
          </div>
          <div className="streak-subheader">Past 7 days</div>
          <div className="days-container">
            {result.length > 0 &&
              result.map((day, index) => (
                <div key={index} className={`day-item ${day.isStreak}`}>
                  <div className="check-icon">
                    {day.isStreak === "yes" ? (
                      <svg
                        width="28"
                        height="28"
                        viewBox="0 0 28 28"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M16.0451 5.25613L15.8309 4.95612C14.9335 3.69985 13.0665 3.69985 12.169 4.95612L11.9548 5.25613C11.481 5.91942 10.6856 6.2746 9.87543 6.18458L8.92028 6.07846C7.48722 5.91922 6.27634 7.13011 6.43557 8.56317L6.54169 9.51831C6.63172 10.3284 6.27653 11.1239 5.61324 11.5977L5.31324 11.8119C4.05696 12.7093 4.05696 14.5764 5.31324 15.4738L5.61324 15.688C6.27653 16.1619 6.63172 16.9573 6.54169 17.7675L6.43557 18.7226C6.27634 20.1556 7.48722 21.3666 8.92028 21.2073L9.87543 21.1012C10.6856 21.0112 11.481 21.3663 11.9548 22.0296L12.169 22.3296C13.0665 23.5858 14.9335 23.5858 15.8309 22.3296L16.0451 22.0296C16.519 21.3663 17.3145 21.0112 18.1246 21.1012L19.0797 21.2073C20.5127 21.3666 21.7237 20.1556 21.5644 18.7226L21.4583 17.7675C21.3683 16.9573 21.7234 16.1619 22.3867 15.688L22.6867 15.4738C23.943 14.5764 23.943 12.7093 22.6867 11.8119L22.3867 11.5977C21.7234 11.1239 21.3683 10.3284 21.4583 9.51831L21.5644 8.56317C21.7237 7.13011 20.5127 5.91922 19.0797 6.07846L18.1246 6.18458C17.3145 6.2746 16.519 5.91942 16.0451 5.25613Z"
                          fill="#F96343"
                        />
                        <path
                          d="M10.625 13.6428L12.6713 15.6891C12.7838 15.8016 12.9662 15.8016 13.0787 15.6891L17.375 11.3928"
                          stroke="white"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    ) : day.isStreak === "future" ? (
                      <svg
                        width="28"
                        height="28"
                        viewBox="0 0 28 28"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M16.0452 5.25613L15.831 4.95612C14.9336 3.69985 13.0665 3.69985 12.1691 4.95612L11.9549 5.25613C11.4811 5.91942 10.6856 6.2746 9.87549 6.18458L8.92034 6.07846C7.48729 5.91922 6.2764 7.13011 6.43563 8.56317L6.54176 9.51831C6.63178 10.3284 6.27659 11.1239 5.6133 11.5977L5.3133 11.8119C4.05702 12.7093 4.05702 14.5764 5.3133 15.4738L5.6133 15.688C6.27659 16.1619 6.63178 16.9573 6.54176 17.7675L6.43563 18.7226C6.2764 20.1556 7.48729 21.3666 8.92034 21.2073L9.87549 21.1012C10.6856 21.0112 11.4811 21.3663 11.9549 22.0296L12.1691 22.3296C13.0665 23.5858 14.9336 23.5858 15.831 22.3296L16.0452 22.0296C16.519 21.3663 17.3145 21.0112 18.1246 21.1012L19.0798 21.2073C20.5128 21.3666 21.7237 20.1556 21.5644 18.7226L21.4583 17.7675C21.3683 16.9573 21.7235 16.1619 22.3868 15.688L22.6867 15.4738C23.943 14.5764 23.943 12.7093 22.6867 11.8119L22.3868 11.5977C21.7235 11.1239 21.3683 10.3284 21.4583 9.51831L21.5644 8.56317C21.7237 7.13011 20.5128 5.91922 19.0798 6.07846L18.1246 6.18458C17.3145 6.2746 16.519 5.91942 16.0452 5.25613Z"
                          fill="#98A2B3"
                        />
                        <path
                          d="M10.625 13.6428L12.6713 15.6891C12.7838 15.8016 12.9662 15.8016 13.0787 15.6891L17.375 11.3928"
                          stroke="white"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    ) : (
                      <svg
                        width="28"
                        height="28"
                        viewBox="0 0 28 28"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M16.0451 5.75613L15.8309 5.45612C14.9335 4.19985 13.0665 4.19985 12.169 5.45612L11.9548 5.75613C11.481 6.41942 10.6856 6.7746 9.87543 6.68458L8.92028 6.57846C7.48722 6.41922 6.27634 7.63011 6.43557 9.06317L6.54169 10.0183C6.63172 10.8284 6.27653 11.6239 5.61324 12.0977L5.31324 12.3119C4.05696 13.2093 4.05696 15.0764 5.31324 15.9738L5.61324 16.188C6.27653 16.6619 6.63172 17.4573 6.54169 18.2675L6.43557 19.2226C6.27634 20.6556 7.48722 21.8666 8.92028 21.7073L9.87543 21.6012C10.6856 21.5112 11.481 21.8663 11.9548 22.5296L12.169 22.8296C13.0665 24.0858 14.9335 24.0858 15.8309 22.8296L16.0451 22.5296C16.519 21.8663 17.3145 21.5112 18.1246 21.6012L19.0797 21.7073C20.5127 21.8666 21.7237 20.6556 21.5644 19.2226L21.4583 18.2675C21.3683 17.4573 21.7234 16.6619 22.3867 16.188L22.6867 15.9738C23.943 15.0764 23.943 13.2093 22.6867 12.3119L22.3867 12.0977C21.7234 11.6239 21.3683 10.8284 21.4583 10.0183L21.5644 9.06317C21.7237 7.63011 20.5127 6.41922 19.0797 6.57846L18.1246 6.68458C17.3145 6.7746 16.519 6.41942 16.0451 5.75613Z"
                          fill="#F04438"
                        />
                        <path
                          d="M10.625 14.1428L12.6713 16.1891C12.7838 16.3016 12.9662 16.3016 13.0787 16.1891L17.375 11.8928"
                          stroke="white"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <rect
                          x="6.21409"
                          y="3.43665"
                          width="26.1818"
                          height="2.58624"
                          rx="1.29312"
                          transform="rotate(47.9467 6.21409 3.43665)"
                          fill="#D92E2E"
                        />
                        <rect
                          x="6.21409"
                          y="3.43665"
                          width="26.1818"
                          height="2.58624"
                          rx="1.29312"
                          transform="rotate(47.9467 6.21409 3.43665)"
                          stroke="#F2F4F7"
                        />
                      </svg>
                    )}
                  </div>
                  <span className="day-text">{day.day}</span>
                </div>
              ))}
          </div>
        </>
    </div>
  );
};

export default LearningStreak;
